import React from 'react';
import PeaceOfMind from '../PeaceOfMind';
import TitleTemplate from '../TitleTemplate';


export default function GrowYourCareer() {
  return (
      <>
      
      <div className=" pt-10 ">
          <TitleTemplate
          title="Live, Grow your career and Have the best time while you are "
          />
            <div className="pb-12">
                <PeaceOfMind
                    imgSrc="/static/images/landingPages/RentInMontreal/rent-in-montreal2.jpg"
                    title="Great Lifestyle"
                    para="With over 150 properties to chose from across some of the most coveted neighbourhoods in the city, you are sure to be spoilt for choice. "
                    
                    
                />
            </div>
            <div className="pb-12">
                <PeaceOfMind
                    imgSrc="/static/images/landingPages/RentInMontreal/rent-in-montreal3.webp"
                    title="Trusted Landlords"
                    para="All curated properties belong to a highly reputable set of landlords ensuring you are served by the best in the business. "
                    order3="2"
                    order4="1"
                   
                />
            </div>
            <div className="pb-12">
                <PeaceOfMind
                    imgSrc="/static/images/landingPages/RentInMontreal/rent-in-montreal4.webp"
                    title="Right people, Right Stay"
                    para="With an array of studios, one, two and three-bedroom options available, there is something on offer for everyone."
                    
                    
                />
            </div>
            
      </div>
      <hr className='md:hidden block' />
      </>
  );
}
